module.exports = __webpack_public_path__ + "img/FeiBiao.8c83a355.png";